import { render, staticRenderFns } from "./DocumentItem.vue?vue&type=template&id=751533db&"
import script from "./DocumentItem.vue?vue&type=script&lang=ts&"
export * from "./DocumentItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports